var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { NotificationsService } from "../../../services/notifications/notifications-service";
import { NotificationEntryTypeEnum } from "../../../models/notifications/notifications.models";
import { ArrayUtils } from "../../../utilities/arrays";
import { autoinject, transient } from "aurelia-dependency-injection";
import { UserClientService } from "../../../services/authentication/user-client.service";
import { NotificationCenterEntryComposer } from "./notification-center-entry-composer";
var Alerts = /** @class */ (function () {
    function Alerts(notificationsService, element, notificationCenterEntryComposer, userClientService) {
        var _this = this;
        this.notificationsService = notificationsService;
        this.element = element;
        this.notificationCenterEntryComposer = notificationCenterEntryComposer;
        this.userClientService = userClientService;
        this.currentUserId = -1;
        this.isOpened = false;
        this.notifications = [];
        this.closeAlerts = function (event) {
            if (!event || !event["propagationStopped"]) {
                _this.preventDefault(event);
                _this.isOpened = false;
                if (!_this.isOpened) {
                    _this.notifications = [];
                }
            }
        };
    }
    Alerts.prototype.attached = function () {
        var _this = this;
        if (!this.userClientService.currentUser) {
            return;
        }
        this.notificationsService.register(this);
        this.currentUserId = this.userClientService.currentUser.id;
        var types = Object.keys(NotificationEntryTypeEnum);
        types.forEach(function (key) {
            var value = NotificationEntryTypeEnum[key];
            _this.notificationCenterEntryComposer.register({ type: value, viewModel: './notifications/classic-notification' }, false);
        });
    };
    Alerts.prototype.preventDefault = function (event) {
        if (event) {
            event.stopPropagation();
        }
    };
    Alerts.prototype.pushedNotification = function (notification) {
        var _this = this;
        if (notification.userId == this.currentUserId) {
            clearTimeout(this.timeout);
            var index = ArrayUtils.findIndex(this.notifications, function (x) { return x.notificationId == notification.notificationId; });
            if (index < 0) {
                this.notifications.unshift(notification);
            }
            else {
                this.notifications.splice(index, 1, notification);
            }
            this.isOpened = true;
            this.timeout = setTimeout(function () {
                _this.isOpened = false;
            }, 10000);
        }
    };
    Alerts.prototype.getTime = function (date) {
        var numToTwoDigits = function (num) {
            return "0".concat(num).slice(-2);
        };
        var dateConverted = new Date(date);
        return numToTwoDigits(dateConverted.getHours()) + ":" + numToTwoDigits(dateConverted.getMinutes());
    };
    Alerts.prototype.dismiss = function ($event, notification) {
        var index = ArrayUtils.findIndex(this.notifications, function (x) { return x.notificationId == notification.notificationId; });
        if (index > -1) {
            this.notifications.splice(index, 1);
        }
        if (this.notifications.length == 0) {
            clearTimeout(this.timeout);
            this.isOpened = false;
        }
        this.preventDefault($event);
    };
    Alerts.prototype.raiseViewAll = function () {
        var _this = this;
        this.isOpened = false;
        setTimeout(function () {
            var changeTextEvent = new CustomEvent("view-all", { detail: {}, bubbles: true });
            _this.element.dispatchEvent(changeTextEvent);
        }, 120);
    };
    Alerts = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationsService,
            Element, NotificationCenterEntryComposer,
            UserClientService])
    ], Alerts);
    return Alerts;
}());
export { Alerts };
